































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { TbGoodsSpecs,TbRole } from '@/http';
import { logoutPanel } from "@/components";
import addRolePanel from "./addRolePanel.vue"
import { Toast,Dialog } from 'vant';
import { padauthList } from "@/common/authpad.js"
@Component({ 
    components: {
        logoutPanel,addRolePanel
    },
})
export default class roleAuth extends Vue {
   
    public $refs: {
    };
    //角色数据
    roleList=[];
    //当前选中的角色id
    activeId = '';
    activeName = '';
    activeInfo:any={}

    /**添加角色 */
    addRoleShow = false;
    //********权限开始
    checkedAll = false;
    /**权限树 */
    authList=padauthList;
    /**实际拥有权限 */
    hasAuthList=[]
    hasAuth2list = []
    isEdit=false;
    authActivename = '';
    //********权限结束
    /**提示弹窗 */
    tipShow = false;
    tipTitle ="";
    tipText="";
    confirmText="";
    cancelText="";
    btnNums=1;
    tipType=1;

    deleteId="";
    isDeleting = false;
    isSaving = false;
    finAuthList = [];
    Loop=null;

    userInfo = {};

    created() {
        this.userInfo = JSON.parse(localStorage.getItem("padUserinfo"));
    }

    async mounted(){
      this.init();
    }

    async init(){
        await this.getRoleList();
        this.activeId = this.roleList.length>0?this.roleList[0].id:'';
        await this.getRoleDetil(this.activeId)
    }
    //获取角色列表
    async getRoleList(){
        let res = await TbRole.GetTbRoleList({
            skip:0,
            count:-1
        })
        this.roleList = res.items;
        console.log('this.roleList',this.roleList);
    }
    async getRoleDetil(id){
        let res = await TbRole.GetTbRoleById(id);
        console.log('ress',res);
        this.activeName = res.name;
        await this.getOptionAuth(res.authorityJson);
    }
    /**获取角色操作权限 */
    async getOptionAuth(auth){
        this.hasAuthList = [];
        let authArr = auth.split(',');
        console.log('authArr',authArr);
        console.log('this.authList',this.authList)
        this.hasAuthList = this.authList.map(v=>{
            return{
                ...v,
                children:v.children&&v.children.length>0? v.children.map(vv=>{
                    return{
                        ...vv,
                        checked:authArr.findIndex(q=>q==vv.value)>-1
                    }
                }):[],
                checked:this.judgeName(v.name,authArr)
            }
        })
        this.checkedAll =  this.hasAuthList.findIndex(v=>v.checked==true)>-1 ? true:false; 
        this.authActivename = this.hasAuthList[0].name;
        this.getAuth2list();
        console.log('this.hasAuthList',this.hasAuthList,this.checkedAll);
    }
    judgeName(name,auth){
        let flag = false;
        let arr = []
        switch (name) {
            case '主页数据':
                arr = ['001','002','003','004','005','006','007'];
                flag = arr.findIndex(v=>auth.some(z=>z==v))>-1
                break;
            case '商品信息':
                arr = ['101','102','103','104','105','106','107','108','109'];
                flag = arr.findIndex(v=>auth.some(z=>z==v))>-1
                break;
            case '商品规格':
                arr = ['201','202'];
                flag = arr.findIndex(v=>auth.some(z=>z==v))>-1
                break;
            case '会员信息':
                arr = ['301','302'];
                flag = arr.findIndex(v=>auth.some(z=>z==v))>-1
                break;
            case '积分设置':
                arr = ['401','402'];
                console.log('flag,',flag,arr);
                flag = arr.findIndex(v=>auth.some(z=>z==v))>-1
                break;
            case '等级设置':
                arr = ['501','502'];
                flag = arr.findIndex(v=>auth.some(z=>z==v))>-1
                break;
            case '收银':
                arr = ['601'];
                flag = arr.findIndex(v=>auth.some(z=>z==v))>-1
                break;
            case '换货':
                arr = ['2501'];
                flag = arr.findIndex(v=>auth.some(z=>z==v))>-1
                break;
            case '退货':
                arr = ['701'];
                flag = arr.findIndex(v=>auth.some(z=>z==v))>-1
                break;
            case '员工信息':
                arr = ['801','802','803','804'];
                flag = arr.findIndex(v=>auth.some(z=>z==v))>-1
                break;
            case '提成设置':
                arr = ['901','902','903','904'];
                flag = arr.findIndex(v=>auth.some(z=>z==v))>-1
                break;
            case '角色与权限':
                arr = ['1001','1002','1003'];
                flag = arr.findIndex(v=>auth.some(z=>z==v))>-1
                break;
            case '店铺信息':
                arr = ['1101','1102'];
                flag = arr.findIndex(v=>auth.some(z=>z==v))>-1
                break;
            case '支付设置':
                arr = ['1201'];
                flag = arr.findIndex(v=>auth.some(z=>z==v))>-1
                break;
            case '配件信息':
                arr = ['1301','1302'];
                flag = arr.findIndex(v=>auth.some(z=>z==v))>-1
                break;
            case '收银设置':
                arr = ['1401','1402'];
                flag = arr.findIndex(v=>auth.some(z=>z==v))>-1
                break;
            case '云同步设置':
                arr = ['1501','1502'];
                flag = arr.findIndex(v=>auth.some(z=>z==v))>-1
                break;
            case '销售总览报表':
                arr = ['2601'];
                flag = arr.findIndex(v=>auth.some(z=>z==v))>-1
                break;
            case '销售报表':
                arr = ['1601'];
                flag = arr.findIndex(v=>auth.some(z=>z==v))>-1
                break;
            case '商品报表':
                arr = ['1701'];
                flag = arr.findIndex(v=>auth.some(z=>z==v))>-1
                break;
            case '会员报表':
                arr = ['1801'];
                flag = arr.findIndex(v=>auth.some(z=>z==v))>-1
                break;
            case '员工报表':
                arr = ['1901'];
                flag = arr.findIndex(v=>auth.some(z=>z==v))>-1
                break;
            case '库存查询':
                arr = ['2001'];
                flag = arr.findIndex(v=>auth.some(z=>z==v))>-1
                break;
            case '库存盘点':
                arr = ['2101'];
                flag = arr.findIndex(v=>auth.some(z=>z==v))>-1
                break;
            case '供应商':
                arr = ['2201','2202','2203'];
                flag = arr.findIndex(v=>auth.some(z=>z==v))>-1
                break;
            case '调拨':
                arr = ['2401','2402','2403','2404','2405'];
                flag = arr.findIndex(v=>auth.some(z=>z==v))>-1
                break;
            case '利润率':
                arr = ['2701'];
                flag = arr.findIndex(v=>auth.some(z=>z==v))>-1
                break;
            case '收银员':
                arr = ['2801','2802','2803','2804'];
                flag = arr.findIndex(v=>auth.some(z=>z==v))>-1
                break;
            case '会员调整':
                arr = ['2901','2902'];
                flag = arr.findIndex(v=>auth.some(z=>z==v))>-1
                break;
            default:
                break;
        }
        return flag;
    }
    getAuth2list(){
        let arr = []
        arr = this.hasAuthList.filter(v=>v.name==this.authActivename)[0].children;
        console.log('hasAuth2list',arr);
        this.hasAuth2list = arr;
    }
    changeAllAuth(){
        this.setCheckBoxVal(this.hasAuthList,this.checkedAll);
    }
    setCheckBoxVal(arr,val){
        arr.forEach(v=>{
            v.checked = val;
            if(v.children&&v.children.length>0){
                this.setCheckBoxVal(v.children,val)
            }
            return;
        })
    }
    showAuth2(item,index){
        console.log('点击蚊子',item);
        this.authActivename = item.name;
        this.getAuth2list();
    }
    checkAllList(item,index){
        console.log('点击复选框',item);
        this.setCheckBoxVal([item],item.checked);
        this.checkedAll =  this.hasAuthList.findIndex(v=>v.checked==true)>-1 ? true:false;
        this.showAuth2(item,index);
    }
    checkAllchildList(item,index){
        console.log('子孩点击复选框',item,index,this.hasAuth2list);
           if(item.checked){
                /**向上选中 */
                // this.hasAuth2list[index].checked = true;
                this.hasAuthList.filter(v=>v.name==this.authActivename)[0].checked = true;
            }else{
                /**含有tab页的一级菜单。如果二级菜单权限为空，就清掉一级菜单权限 */
                if(this.hasAuth2list.filter(v=>v.checked).length==0){
                    // this.hasAuthList[index].checked = false;
                    this.hasAuthList.filter(v=>v.name==this.authActivename)[0].checked = false;
                }

            }
            this.checkedAll =  this.hasAuthList.findIndex(v=>v.checked==true)>-1 ? true:false;
            console.log('this.hasAuthList',this.hasAuthList);
    }
    clickCount:number = 0;
    async chooseRole(item){
        this.clickCount++
        setTimeout( async ()=>{
            if(this.clickCount == 1){
                this.clickCount = 0
                if(this.isEdit) {
                    Toast('请先保存当前页');
                    return;
                }
                this.activeId = item.id;
                await this.getRoleDetil(this.activeId);
            }else if(this.clickCount>1){
                this.clickCount = 0
                await this.fTouchstart(item)
                setTimeout( async ()=>{
                    await this.touchend()
                },1000)
            }
        },300)
        
    }

    cancelFun(){
        this.addRoleShow = false;
    }
    confirmAddRole(){
        this.init();
    }

    addRole(){
        if(this.isEdit){
            Toast("请先保存当前页");
            return;
        }
        this.addRoleShow = true;
        this.$nextTick(()=>{
            $('#role_input').focus();
        })
    }
    /**删除角色 */
    async deleteFun(){
        if(this.isDeleting) return;
        this.isDeleting = true;
        try {
            let res = await TbRole.DeleteTbRole(this.deleteId);
            this.isDeleting = false;
            Toast("删除成功");
            await this.init();
        } catch (error) {
            this.isDeleting = false;
        }
    }
    /**提示弹窗 */
    async tipConfirm(){
        switch (this.tipType) {
            case 1:
                this.deleteFun()
                break;
            case 2:
                this.addFun()
            break;
            case 3:
                //退出登录
                localStorage.removeItem("padUserinfo");
                localStorage.removeItem("padToken");
                this.$router.push("/pad/padLogin2")
            break;
            default:
                break;
        }
        this.tipShow = false;
    }
    tipCancel(){
        this.tipShow = false;
    }
    //编辑
    showEdit(){
        this.isEdit = !this.isEdit;
    }
    //保存编辑权限
    async saveEdit2(){
        this.tipTitle = "保存提醒";
        this.tipText = `确认保存吗？`;
        this.btnNums=2;
        this.confirmText = "确认";
        this.cancelText = "取消"
        this.tipType = 2;
        this.$nextTick(()=>{
            this.tipShow = true;
        })
    }
    async addFun(){
        if(this.isSaving) return;
        this.isSaving = true;
        this.finAuthList=[];
        await this.getAuthJson(this.hasAuthList);
        console.log('this.finAuthList',this.finAuthList);
        try {
            let res =await TbRole.PutTbRole({
                id:this.activeId,
                name:this.activeName,
                authorityJson:this.finAuthList.join(',')
            })
            Toast('保存成功');
            this.isSaving=false;
            this.isEdit = false;
            this.tipShow=false;
            setTimeout(function() {
                this.tipTitle = "操作提醒";
                this.tipText = `权限已保存，重新登录后生效。确认要重新登录吗？`;
                this.btnNums=2;
                this.confirmText = "确认";
                this.cancelText = "取消"
                this.tipType = 3;
                this.tipShow = true;
            }.bind(this), 1000);
        } catch (error) {
            this.isSaving=false;
        }
    }
    getAuthJson(arr){
        console.log('arr');
        arr.forEach(v=>{
            if(v.checked){
                if(v.value){
                    this.finAuthList.push(v.value);
                }
                if(v.children&&v.children.length>0){
                    this.getAuthJson(v.children)
                }
                return;
            }else{
                if(v.children&&v.children.length>0){
                    this.getAuthJson(v.children)
                }
                return;
            }
        })
    }
    //取消权限保存
    async cancelFun2(){
        await this.getRoleDetil(this.activeId)
        this.isEdit = false;
    }
    fTouchstart(item){
        console.log('touchstart',item);
        if(item.name=='收银员' || item.name=='管理员') return;
        clearInterval(this.Loop); //再次清空定时器，防止重复注册定时器
        this.Loop = setTimeout(function() {
            if(!this.hasAuth('1003')){
                Dialog.alert({
                    title: '提示',
                    message: "暂无操作权限",
                    confirmButtonText: '确定',
                    confirmButtonColor:'#0491A7'
                    }).then(() => {
                    
                    });
                return;
            }
            this.tipTitle = "删除提醒";
            this.tipText = `确定删除“${item.name}”角色吗？`;
            this.btnNums=2;
            this.confirmText = "确定删除";
            this.cancelText = "取消"
            this.tipType = 1;
            this.deleteId = item.id;
            this.tipShow = true;
        }.bind(this), 1000);//手指或者鼠标按下等待的时间
    }
    touchend(){
        // if(!this.isManage)return;
        console.log('touchend');
        clearInterval(this.Loop);
    }
    /**判断权限 */
    hasAuth(auth) {
        let val = false;
        let btnPermissionsStr = this.userInfo['authorityJson'].split(',');
        if (btnPermissionsStr == undefined || btnPermissionsStr == null) {
        val = false;
        }
        if (btnPermissionsStr.some(v=>v==auth)) {
        val = true;
        }
        return val;
    }
}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/views/padViews/staff/components/roleAuth.vue